// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyA2dVt5iKniTN9_6vQf7y2AhDgUkWROi-A",
    authDomain: "gsmbd-c0193.firebaseapp.com",
    projectId: "gsmbd-c0193",
    storageBucket: "gsmbd-c0193.appspot.com",
    messagingSenderId: "325272846958",
    appId: "1:325272846958:web:57a673aecc4406ac5c9c7f",
    measurementId: "G-THBG1G98K2"
  };

  export default firebaseConfig;